<template>
  <label
    :class="{
      'dotcom-radio--disabled': disabled,
      'dotcom-radio--visually-hidden': visuallyHidden,
    }"
    class="dotcom-radio"
  >
    <div class="dotcom-radio__form-input" :class="{ selected: checked }">
      <dotcom-icon
        v-if="!visuallyHidden"
        :key="checked"
        name="circle"
        :art="checked ? 'solid' : 'light'"
        :color="checked ? '--c-primary-color-2' : '--c-primary-neutral-1'"
      />
      <input
        :checked="checked"
        :value="inputValue"
        :name="name"
        :disabled="disabled"
        type="radio"
        class="dotcom-radio__input"
        @change="$emit('input', inputValue)"
      />
    </div>
    <div class="dotcom-radio__text">
      <slot />
    </div>
  </label>
</template>

<script>
export default {
  name: 'Radio',

  components: {
    DotcomIcon: () => {
      return import(
        /* webpackChunkName: "dotcom-icon" */
        '@/modules/icon/Icon'
      )
    },
  },

  props: {
    name: {
      type: String,
      default: '',
    },

    value: {
      type: [String, Number, Boolean],
      default: '',
    },

    inputValue: {
      type: [String, Number, Boolean],
      required: true,
    },

    disabled: Boolean,
    visuallyHidden: Boolean,
  },

  computed: {
    checked() {
      return this.inputValue === this.value
    },
  },
}
</script>

<style lang="postcss" scoped>
.darkgreen .dotcom-radio {
  &:not(&.dotcom-radio--visually-hidden) {
    .dotcom-radio__form-input {
      &::before {
        background-color: var(--c-primary-neutral-3);
      }

      svg.dotcom-icon {
        color: var(--c-primary-neutral-3);
      }
    }
  }

  &.dotcom-radio-group__radio--selected {
    &:not(&.dotcom-radio--visually-hidden) {
      .dotcom-radio__form-input {
        svg.dotcom-icon {
          color: var(--c-primary-color-2);
        }
      }
    }
  }
}

.dotcom-radio {
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;

  &--disabled {
    cursor: not-allowed;
  }

  &--visually-hidden {
    display: flex;
    justify-content: center;

    .dotcom-radio__form-input {
      width: 0;
    }
  }

  & > *,
  & >>> * {
    pointer-events: none;
  }

  &:not(&.dotcom-radio--visually-hidden) {
    &:first-child {
      margin-top: 1em;
    }
    .dotcom-radio__form-input {
      &::before {
        content: '';
        background-color: var(--c-primary-neutral-1);
        opacity: 0.05;
        border-radius: 100%;
        display: inline-block;
        width: 2.5em;
        height: 2.5em;
        visibility: hidden;
        position: absolute;
        top: -0.75em;
        left: -0.75em;
      }
    }
  }

  &:hover:not(&.dotcom-radio--visually-hidden) .dotcom-radio__form-input {
    &::before {
      visibility: visible;
    }

    &.selected::before {
      background-color: var(--c-primary-color-2);
    }
  }

  &:active:not(&.dotcom-radio--visually-hidden) .dotcom-radio__form-input {
    &::before {
      opacity: 0.2;
    }

    &.selected::before {
      background-color: var(--c-primary-color-2);
    }
  }

  &:focus {
    /* outline: 2px dotted var(--c-primary-neutral-1); */
  }

  &:not(&.dotcom-radio--visually-hidden) .dotcom-radio__form-input {
    margin-right: 10px;
  }
}

.dotcom-radio__form-input {
  width: 20px;
  margin-right: 2px;
}

.dotcom-radio__input {
  position: absolute;
  opacity: 0;
  left: 0;
  top: 0;
}

.dotcom-radio-group__items.dotcom-radio-group__items--horizontal
  .dotcom-radio:first-child {
  margin-top: 0;
}
</style>
